import {PlayerColor} from '@colonist/game-states'
import {Avatar} from '../../../../common/Avatar'
import styles from './AvatarList.module.scss'
import React from 'react'
import {GameClientUserState} from '@colonist/game-base-types'
import {clsx} from 'clsx'
import {Tooltip} from '../../../../common/Tooltip'
import {T} from '../../../../common/T'

interface AvatarListProps {
    playerUserStates: GameClientUserState[]
    currentPlayerPerspective: PlayerColor
    onChangePerspective: (color: PlayerColor) => void
}

export const AvatarList = ({
    playerUserStates,
    currentPlayerPerspective,
    onChangePerspective,
}: AvatarListProps) => (
    <div className={styles.avatarContainer}>
        {playerUserStates.map((player, index) => (
            <Tooltip
                content={<T id={{
                    key: 'strings:game.tooltips.replay.changePerspective',
                    options: {playerColor: PlayerColor[player.selectedColor]},
                }} />}
                delay={0}
                key={player.selectedColor}
                menuClassName={styles.tooltipMenu}
                position="bottom">
                <Avatar
                    className={clsx(styles.replayControlAvatar, {
                        [styles.selected]: player.selectedColor === currentPlayerPerspective})}
                    color={player.selectedColor}
                    image={player.databaseIcon}
                    onClick={() => onChangePerspective(player.selectedColor)}
                />
            </Tooltip>

        ))}
    </div>
)
